import { Auth } from './auth';

export class Display extends Auth {

}
